



const env = import.meta.env.APP_ENV

let isTest = import.meta.env.APP_ENV_VALUE
export let baseURL = ''
export let circleURL = '' 


if (env == 'dev') {
    baseURL = '/api'
    circleURL = 'http://192.168.50.132:4001'
} else {
    if (isTest == 'test') {
        baseURL = 'https://test.slidesorator.com'
        circleURL = 'https://test.circle.slidesorator.com'
    } else if (isTest == 'pro') {
        baseURL = 'https://www.slidesorator.com'
        circleURL = 'https://circle.slidesorator.com'
    }  else if (isTest == 'lianxiang') {
        baseURL = 'https://apply.slidesorator.com'
        circleURL = 'https://test.slidesorator.com'
    }
}


export const unityEnv = isTest != 'pro' ? 'development' : 'release'

// baseURL = 'https://www.slidesorator.com'
// baseURL = 'https://test.slidesorator.com'

export const UnityAPIURL = () => {
    if (baseURL == 'https://www.slidesorator.com' || baseURL == 'https://test.slidesorator.com' || baseURL == 'https://apply.slidesorator.com' ) {
        return baseURL
    } else {
        // return 'http://192.168.50.208:8081'
        return 'http://192.168.50.55:8081'
    }
}

export const UnityURL = () => {
    if (baseURL == 'https://www.slidesorator.com' || baseURL == 'https://test.slidesorator.com'  || baseURL == 'https://apply.slidesorator.com' ) {
        return baseURL
    } else {
        return 'http://192.168.50.132:5502/public'
    }
}


export const ShearURL = () => {
    if (baseURL == 'https://www.slidesorator.com' || baseURL == 'https://test.slidesorator.com'|| baseURL == 'https://apply.slidesorator.com' ) {
        return baseURL
    } else {
        return 'http://192.168.50.132:4000'
    }
}

export const rechargeURL = () => {
    if (baseURL == 'https://www.slidesorator.com' || baseURL == 'https://test.slidesorator.com'  || baseURL == 'https://apply.slidesorator.com' ) {
        return baseURL
    } else {
        return 'http://192.168.50.132:4000'
    }
}



